import React, { Fragment } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
const dcar_score_icon = require('static/dcar-score.png')

export interface IRankItem {
  series_id: number
  series_name: string // 车系名称
  score: number // 懂车分
  rank: number // 排名
  single_highest_desc: string // 单项最高描述
  single_highest_score: number // 单项最高得分
}
export default function SeriesRank({
  rankItems,
  seriesType,
}: {
  rankItems: IRankItem[]
  seriesType: string
}) {
  return (
    <>
      <div className="rank-title">同级{seriesType}排行</div>
      <div className="head-grid">
        <span className="rank-head">排名</span>
        <span className="series-name-head">对比车系</span>
        <span className="score-head" />
        <span className="single-item-head">单项最高</span>
      </div>
      <div className="rank-grid">
        {rankItems.map((rankItem, index) => {
          const {
            rank,
            series_id,
            series_name,
            score,
            single_highest_desc,
            single_highest_score,
          } = rankItem
          return (
            <Fragment key={`${series_id} ${index}`}>
              <span>{rank}</span>
              <span className="series-name line-1">
                <a
                  href={`/auto/series/${series_id}`}
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                  onClick={() => {
                    sendTeaCommEvent('click_dcar_score_series_rank', {
                      rank: index,
                      car_series_id: series_id,
                      car_series_name: series_name,
                    })
                  }}
                >
                  {series_name}
                </a>
              </span>
              <span className="score">
                {score ? `${(score / 100).toFixed(2)}分` : '暂无评分'}
              </span>
              <span className="single-item">
                {single_highest_desc && single_highest_score && (
                  <>
                    <span className="single-highest-desc">
                      <span>{single_highest_desc}</span>
                    </span>
                    <span className="single-highest-score">
                      {single_highest_score}分
                    </span>
                  </>
                )}
              </span>
            </Fragment>
          )
        })}
      </div>

      <style jsx>
        {`
          .rank-title {
            margin: 12px 0;
            color: #1f2129;
            font-size: 14px;
            font-weight: 500;
          }
          .head-grid {
            display: grid;
            grid-template-columns: 2fr 4fr 3fr 4fr;
            grid-template-rows: 32px;
            justify-items: start;
            align-items: center;
            color: #1f2129;
            font-size: 12px;
            line-height: 1.5;
            background-color: rgba(255, 204, 50, 0.1);
          }
          .score-head {
            background-size: cover;
            background-position: center;
            background-image: url('${dcar_score_icon}');
            width: 36px;
            height: 14px;
          }
          .rank-head,
          .series-name-head,
          .score-head,
          .single-item-head {
          }
          .rank-grid > span,
          .head-grid > span {
            margin-left: 8px;
          }
          .rank-grid {
            display: grid;
            grid-template-columns: 2fr 4fr 3fr 4fr;
            grid-template-rows: repeat(6, 18px);
            row-gap: 16px;
            justify-items: start;
            align-items: center;
            color: #1f2129;
            font-size: 12px;
            line-height: 1.5;
            margin-top: 10px;
          }
          .series-name:hover {
            color: #e62021;
          }
          .series-name {
            max-width: 100%;
          }
          .score {
            color: #e62021;
            font-weight: 600;
          }
          .single-item {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .single-highest-desc {
            padding: 1px 4px;
            border-radius: 2px;
            background-color: rgba(179, 125, 18, 0.1);
            color: #b37d12;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .single-highest-desc > span {
            font-size: 12px;
            line-height: 14px;
            transform: scale(0.857);
            transform-origin: center;
          }
          .single-highest-score {
            margin-left: 4px;
          }
        `}
      </style>
    </>
  )
}
